import * as React from "react";
import { Field, FormSpy } from "react-final-form";

import { Info } from "@livechat/design-system-icons";
import { DesignToken, Icon, SpacingToken, Text } from "@livechat/design-system-react-components";

import { CheckboxWithLabelDescription, CheckboxWithLabelFinalForm } from "components/form";
import Block from "components/layout/Block";
import Flex from "components/layout/Flex";
import { StyledLink } from "components/links/StyledLink";
import Role from "constants/role";
import { withVar } from "themes/helpers";

import { AgentFormSection } from "./AgentFormSection";
import { AgentFormSectionId } from "./constants";

interface IProps {
  canAccessSettings: boolean;
}

const NotificationsManagement: React.FC<IProps> = ({ canAccessSettings }) => (
  <FormSpy
    subscription={{ values: true }}
    render={props => (
      <AgentFormSection header={{ id: AgentFormSectionId.EmailNotifications, component: "Email notifications" }}>
        {/* @ts-expect-error TS(2322) */}
        <Field component={CheckboxWithLabelFinalForm} type="checkbox" name="settings.emailNotificationsActive">
          <Text>Send me email notifications</Text>
        </Field>
        <CheckboxWithLabelDescription>
          {canAccessSettings ? (
            <>
              <Text size="sm" customColor={withVar(DesignToken.ContentBasicSecondary)}>
                Be notified of any new tickets assigned to you and updates in your already assigned tickets.
              </Text>
              <Flex
                alignItems="flex-start"
                gap={withVar(SpacingToken.Spacing2)}
                paddingTop={withVar(SpacingToken.Spacing4)}
              >
                <Icon size="small" source={Info} customColor={withVar(DesignToken.ContentBasicSecondary)} />
                <Text size="sm" customColor={withVar(DesignToken.ContentBasicSecondary)}>
                  Check notifications for a specific team or unassigned tickets in{" "}
                  <StyledLink kind="link-light" to="/settings/notifications">
                    <Text size="sm">Settings &gt; Email notifications</Text>
                  </StyledLink>{" "}
                  section.
                </Text>
              </Flex>
              <Flex
                alignItems="flex-start"
                gap={withVar(SpacingToken.Spacing2)}
                paddingTop={withVar(SpacingToken.Spacing4)}
              >
                <Icon size="small" source={Info} customColor={withVar(DesignToken.ContentBasicSecondary)} />
                <Text size="sm" customColor={withVar(DesignToken.ContentBasicSecondary)}>
                  Regardless of this setting, you&lsquo;ll always be notified when someone adds or removes you from the
                  ticket followers.
                </Text>
              </Flex>
            </>
          ) : (
            <>
              <Text size="sm" customColor={withVar(DesignToken.ContentBasicSecondary)}>
                <StyledLink kind="link-light" to="/subscription">
                  <Text size="sm">Upgrade your account</Text>
                </StyledLink>{" "}
                to see what notifications will be sent to you.
              </Text>
            </>
          )}
        </CheckboxWithLabelDescription>
        <Block paddingTop={withVar(SpacingToken.Spacing6)}>
          <Field
            name="settings.weeklyReports"
            // @ts-expect-error TS(2322)
            component={CheckboxWithLabelFinalForm}
            disabled={props.values.permission !== Role.Owner}
            type="checkbox"
          >
            <Text>Send me weekly summary emails</Text>
          </Field>
          <CheckboxWithLabelDescription>
            <Text size="sm" customColor={withVar(DesignToken.ContentBasicSecondary)}>
              Let me see the summary of last week activities and reports. This report is available to Admins only.
            </Text>
          </CheckboxWithLabelDescription>
        </Block>
      </AgentFormSection>
    )}
  />
);
export default NotificationsManagement;
